(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    // Select all <div> elements with class 'slideshow__image'
    let slideshowImages = document.querySelectorAll('.slideshow__image');

    // Log the number of slideshow images found
    console.log(`Found ${slideshowImages.length} slideshow images.`);

    // Loop through each slideshow image container
    slideshowImages.forEach((container, index) => {
        // Get the aria-label value from the slideshow image container
        let altText = container.getAttribute('aria-label');

        // Select the <img> element within the <picture> tag inside the slideshow image container
        let img = container.querySelector('picture img');

        // Log the details for debugging
        console.log(`Processing container:`, container);
        console.log(`Found image element:`, img);
        
        // Check if the img element exists
        if (img) {
            // Set a delay before setting the alt attribute
            setTimeout(() => {
                // Set the alt attribute using the aria-label value
                if (altText) {
                    img.setAttribute('alt', altText);
                    console.log(`Set alt attribute to: ${altText} for image:`, img);
                } else {
                    console.log(`No aria-label found for the image in container:`, container);
                }
            }, (index + 1) * 500); // Delay based on the index (500ms for the first, 1000ms for the second, etc.)
        } else {
            console.log(`Image is hidden or not found for container:`, container);
        }
    });
});







                
  } catch(e) { console.error(e); }
})();
})();
